import { render, staticRenderFns } from "./RestaurantsInvoicesStats.vue?vue&type=template&id=68603569&"
import script from "./RestaurantsInvoicesStats.vue?vue&type=script&lang=js&"
export * from "./RestaurantsInvoicesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports